export default "__VITE_ASSET__BnZ_SIKF__"